import { render, staticRenderFns } from "./CommentaryDialog.vue?vue&type=template&id=38608488&scoped=true"
import script from "./CommentaryDialog.vue?vue&type=script&lang=js"
export * from "./CommentaryDialog.vue?vue&type=script&lang=js"
import style0 from "./CommentaryDialog.vue?vue&type=style&index=0&id=38608488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38608488",
  null
  
)

export default component.exports